<template>
  <TimelineCard>
    <template #header>
      <div class="flex items-center gap-2 flex-1 min-w-0">
        <div class="flex items-center gap-2 flex-wrap flex-1 min-w-0">
          <h3 class="font-semibold text-slate-900 text-sm m-0 leading-6 sm:text-[0.8125rem]">
            {{ smsMessage.direction === 'OUTBOUND' ? 'SMS sent' : 'SMS received' }}
          </h3>

          <TimelineTag
            :icon="SmsDirectionIcon[smsMessage.direction]"
            :label="SmsDirectionName[smsMessage.direction]"
            :variant="smsMessage.direction === 'OUTBOUND' ? 'orange' : 'green'"
          />
        </div>
      </div>

      <div class="flex items-center gap-2 flex-shrink-0 text-xs text-slate-500">
        <span>{{ smsMessage.fromPhone }}</span>
        <Icon
          name="mdi:arrow-right"
          size="14"
        />
        <span>{{ smsMessage.toPhone }}</span>
      </div>
    </template>

    <template #content>
      <div class="mt-2 text-[0.8125rem] leading-relaxed text-slate-700 sm:text-xs">
        <p class="whitespace-pre-wrap m-0">
          {{ smsMessage.body }}
        </p>
      </div>
    </template>

    <template #footer>
      <TimelineFooter
        :author-name="smsMessage.direction === 'OUTBOUND' ? 'System' : smsMessage.fromPhone"
        :contact="smsMessage.Contact ? {
          id: smsMessage.contactId!,
          firstName: smsMessage.Contact.firstName,
          lastName: smsMessage.Contact.lastName,
        } : undefined"
        :business="smsMessage.Business ? {
          id: smsMessage.businessId!,
          name: smsMessage.Business.name,
        } : undefined"
        :created-at="smsMessage.createdAt"
      />
    </template>
  </TimelineCard>
</template>

<script setup lang="ts">
import type { SmsMessage } from '@prisma/client'
import { SmsDirectionIcon, SmsDirectionName } from '../ActivityFeed/types'
import TimelineCard from '../ActivityFeed/Base/TimelineCard.vue'
import TimelineTag from '../ActivityFeed/Base/TimelineTag.vue'
import TimelineFooter from '../ActivityFeed/Base/TimelineFooter.vue'

type SmsMessageWithRelations = SmsMessage & {
  Business?: { id: string; name: string } | null
  Contact?: { id: string; firstName: string; lastName: string } | null
}

defineProps<{
  smsMessage: SmsMessageWithRelations
}>()
</script>
